module.exports = __webpack_public_path__ + "img/sentosa_zong_jubu.39600f3e.png";